import React from 'react';

import { debounce } from 'lodash';
import { func, number, shape, string } from 'prop-types';

import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';

import Text from 'components/Common/Text';

import { debounceIntervalShort } from 'constants/debounceInterval';

import s from './SingleSelectInput.css';

const SingleSelectInput = ({
  contextId,
  handleDeleteResponse,
  handleSaveResponse,
  initialValue,
  prompt,
  responseId,
  setManualClose,
}) => {
  const handleSelectItem = response => {
    handleSaveResponse({ value: response, prompt });
    setManualClose(true);
  };

  const handleDelete = async () => {
    handleDeleteResponse({ promptId: prompt.id, contextId, responseId });
    setManualClose(true);
  };

  return (
    <>
      <Text variant="titleMdBold" mb={1.5}>
        {prompt.text}
      </Text>
      <List className={s.list}>
        {prompt.options.map(opt => (
          <ListItemButton
            selected={initialValue?.[0] === opt.id}
            key={opt.id}
            className={s.listItem}
            onClick={debounce(
              () => handleSelectItem([opt.id]),
              debounceIntervalShort,
            )}
          >
            <Text>{opt.value}</Text>
          </ListItemButton>
        ))}
        <ListItemButton onClick={handleDelete}>Clear</ListItemButton>
      </List>
    </>
  );
};

SingleSelectInput.propTypes = {
  contextId: number,
  handleDeleteResponse: func.isRequired,
  handleSaveResponse: func.isRequired,
  initialValue: string,
  prompt: shape({}).isRequired,
  responseId: number,
  setManualClose: func.isRequired,
};

SingleSelectInput.defaultProps = {
  contextId: undefined,
  initialValue: '',
  responseId: undefined,
};

export default SingleSelectInput;
